import { useState } from 'react'
import { supabase } from '../../lib/supabase'
import { useAuth } from '../../contexts/AuthContext'
import { useToast, humanizeError } from '../shared/Toast'

export const CATEGORIES = [
  { value: 'lab_result', label: 'Lab result' },
  { value: 'specialist_letter', label: 'Specialist letter' },
  { value: 'discharge_summary', label: 'Discharge summary' },
  { value: 'prescription', label: 'Prescription' },
  { value: 'legal_document', label: 'Legal document' },
  { value: 'care_plan', label: 'Care plan' },
  { value: 'other', label: 'Other' },
]
const ACCEPT = 'application/pdf,image/jpeg,image/png'

export default function DocumentForm({ recipientId, onDone, onCancel }) {
  const { user } = useAuth()
  const toast = useToast()
  const [file, setFile] = useState(null)
  const [category, setCategory] = useState('lab_result')
  const [description, setDescription] = useState('')
  const [documentDate, setDocumentDate] = useState('')
  const [busy, setBusy] = useState(false)

  async function save() {
    if (!file) return toast.error('Choose a file to upload.')
    if (file.size > 25 * 1024 * 1024) return toast.error('File must be under 25MB.')
    setBusy(true)
    try {
      const ext = file.name.split('.').pop()
      const path = `${recipientId}/doc-${Date.now()}.${ext}`
      const { error: upErr } = await supabase.storage.from('documents').upload(path, file, { upsert: false, contentType: file.type })
      if (upErr) throw upErr
      const { error } = await supabase.from('documents').insert({
        care_recipient_id: recipientId,
        uploaded_by: user.id,
        file_name: file.name,
        file_url: path,
        file_size_bytes: file.size,
        category,
        description: description.trim() || null,
        document_date: documentDate || null,
      })
      if (error) throw error
      toast.success('Document uploaded.')
      // Passed back so callers can name the file — existing callers ignore it.
      onDone({ file_name: file.name, category })
    } catch (err) {
      toast.error(humanizeError(err))
    } finally {
      setBusy(false)
    }
  }

  return (
    <div onClick={() => !busy && onCancel()} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 200, display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}>
      <div onClick={(e) => e.stopPropagation()} style={{ background: 'var(--bg)', width: '100%', maxWidth: 'var(--maxw)', borderTopLeftRadius: 20, borderTopRightRadius: 20, padding: 20, maxHeight: '92dvh', overflowY: 'auto' }}>
        <div className="spread" style={{ marginBottom: 12 }}>
          <h2 className="title" style={{ fontSize: 20 }}>Upload document</h2>
          <button onClick={onCancel} style={{ background: 'none', border: 'none', fontSize: 22, color: 'var(--muted)' }}>✕</button>
        </div>
        <div className="stack">
          <div className="field">
            <label className="label">File (PDF or image)</label>
            <input type="file" accept={ACCEPT} onChange={(e) => setFile(e.target.files?.[0] || null)} />
            {file && <span className="badge mt-4">📎 {file.name}</span>}
          </div>
          <div className="field">
            <label className="label">Category</label>
            <select className="select" value={category} onChange={(e) => setCategory(e.target.value)}>
              {CATEGORIES.map((c) => <option key={c.value} value={c.value}>{c.label}</option>)}
            </select>
          </div>
          <div className="field"><label className="label">Document date</label><input type="date" className="input" value={documentDate} onChange={(e) => setDocumentDate(e.target.value)} /></div>
          <div className="field"><label className="label">Description</label><input className="input" value={description} onChange={(e) => setDescription(e.target.value)} placeholder="Optional" /></div>
          <button className="btn btn-lg btn-block" onClick={save} disabled={busy}>{busy ? <span className="spinner" /> : 'Upload'}</button>
        </div>
      </div>
    </div>
  )
}
